type Props = {
  children: JSX.Element[] | JSX.Element;
};

export default function FormRoot({ children }: Props) {
  return <div className="flex flex-col gap-6">{children}</div>;
}
